module.exports = __webpack_public_path__ + "img/box.0fe91586.svg";